import * as actionTypes from './actions';

let tablet = JSON.parse(localStorage.getItem('tablet'));
const initialState =
  tablet === true
    ? {tablet: false, assistants: true}
    : {tablet: false, assistants: false};

const TabletCourseReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TABLETCOURSE:
      if (action.payload.assistants === true) {
        localStorage.setItem('tablet', true);
      } else {
        localStorage.setItem('tablet', false);
      }
      return {
        ...state,
        tablet: action.payload.tablet,
        assistants: action.payload.assistants,
      };
    default:
      return state;
  }
};

export default TabletCourseReducer;
